// src/modules/app-views/_apps/appmulti/orders/pages/Init/components/tableColumns/valueColumn.js
// *******************************************************************************
// VALUE COLUMN
// *******************************************************************************
import translateX from 'utils/translateX';
import financialService from 'services/financialService';

const valueColumn = buildColumnProps => ({
  key: 'value',
  title: translateX('value'),
  dataIndex: 'totalInOrderDate',
  ...buildColumnProps('totalInOrderDate.totalToPay'),
  align: 'right',
  render: (_, record) =>
    financialService.formatNumber(record?.totalInOrderDate?.totalToPay ?? 0, {
      decimals: 2,
      locale: 'pt-BR',
    }),
});

export default valueColumn;
